import { ADD_PROPERTY, ALTERNATE_ADD_PROPERTY_KEY_ID, RESET_ADD_PROPERTY } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction } from "../../types";


export interface AddPropertyState {
    loading: boolean;
    error: boolean;
    keyId: number;
    success: boolean;
    enotif_addable: boolean | undefined;
    message: string;
    status: number;
}

// Define an initial state value for the app
const initialState: AddPropertyState = {
    loading: false,
    error: false,
    enotif_addable: false,
    success: false,
    keyId: 0,
    message: "",
    status: 0
}
  
function addPropertyReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case ADD_PROPERTY.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case ADD_PROPERTY.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,

            }

        case ADD_PROPERTY.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case ALTERNATE_ADD_PROPERTY_KEY_ID:
            return {
                ...state,
                keyId: (state.keyId === 0) ? 1 : 0
            }
        
        case RESET_ADD_PROPERTY:
            return {
                ...initialState,
                keyId: state.keyId
            }
        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default addPropertyReducer;